<template>
  <div class="cloud-platform">
    <AppBar />
    <div class="page-content">
      <div class="cloud-platform-canvas">
        <div class="cloud-platform-background">
          <img :src="top.imgBack" alt="" />
        </div>
        <div class="por-container">
          <div class="solution-info">
            <div class="solution-info-title">{{ top.title }}</div>
            <div class="solution-info-content" v-html="top.content">
              <!-- 利用在线招聘流程，帮助企业实现智能、便捷的招聘模式，
              建立企业自己的人才储备机制 -->
            </div>
          </div>
        </div>
      </div>
      <div ref="nav" class="staff-manage-nav">
        <div ref="navTabs" class="staff-manage-nav-tabs" :style="{width: navWidth+'%', height: navHeight+'px'}">
          <div
            v-for="(item, index) in navList"
            :key="index"
            :class="['staff-manage-nav-item', topNaviId === item.id ? 'top-nav-item' : '']"
            @click="goAnchor(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div style="padding-top: 60px;">
        <div ref="data-security" class="data-security">
          <div class="title">企业人力资源系统面临的问题</div>
          <div class="data-security-content">
            <div v-for="(item, index) in dataSecurityList" :key="index" class="data-security-list-item">
              <img :src="item.icon" alt="" class="list-item-icon" />
              <div class="list-item-title">
                {{ item.title }}
              </div>
              <div class="data-security-text">
                <div class="list-item-text">
                  {{ item.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="background-color: #f7f9fc;">
        <div style="background-color: #fff; width: 100%; height: 60px;"></div>
        <div ref="architecture" class="architecture">
          <div class="title">人力系统综合平台，赋能企业信息数字化</div>
          <div class="architecture-content">
            <img :src="architectureImg" alt="" />
          </div>
        </div>
      </div>
      <div>
        <div ref="introduction" class="introduction">
          <div class="title">制造型企业的首选人力资源系统</div>
          <div v-if="introductionTagList.length != 0" class="introduction-content">
            <div class="introduction-tag">
              <div
                v-for="(item, index) in introductionTagList"
                :key="index"
                class="introduction-tag-item"
                :class="{'display-tag-item': index === introductionTagActiveIndex}"
                @click="displayTag(index)"
              >
                <div class="tag-item-title">
                  <div class="title-text">{{ item.title }}</div>
                  <img v-if="index !== introductionTagActiveIndex" :src="require('@/assets/cloudplatform/icon/right-arrow.png')" alt="" />
                  <img v-else :src="require('@/assets/cloudplatform/icon/down-arrow.png')" alt="" />
                </div>
                <div class="tag-item-describe">
                  <div
                    v-for="(textItem, textIndex) in item.describeList"
                    :key="textIndex"
                    class="describe"
                  >
                    {{ textItem }}
                  </div>
                </div>
              </div>
            </div>
            <transition name="introduction-fade" mode="out-in">
              <div :key="introductionTagActiveIndex" class="fade-content">
                <img :src="introductionTagList[introductionTagActiveIndex].img" alt="" />
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getColumnChild, getColumnDetail } from '@/api/column';
import { getContentList, getContentDetail } from '@/api/content';
export default {
  name: 'CloudPlatform',
  data () {
    return {
      top: {
        title: '',
        content: '',
        imgBack: require('@/assets/cloudplatform/canvas.gif'),
      },
      navWidth: 80,
      navHeight: 60,
      offsetTop: 0,
      scrollTop: 0,
      position: 0,
      valueIndex: null,
      topNaviId: null,
      navList: [
        {
          title: '管理难点',
          id: 'data-security',
        },
        {
          title: '综合平台',
          id: 'architecture',
        },
        {
          title: '推荐功能',
          id: 'introduction',
        },
      ],
      dataSecurityList: [
        // {
        //   icon: require('@/assets/cloudplatform/data-security1.png'),
        //   title: '数据孤岛',
        //   text: '各个版块独立运行或各个分子公司使用不同的系统，导致数据无法共享互通。',
        // },
      ],
      architectureImg: '',
      introductionTagList: [
        // {
        //   title: '管理制度体系化，业务流程标准化',
        //   img: require('@/assets/cloudplatform/introduction1.png'),
        //   describeList: [
        //     '从企业的人员规划出发，实现对企业人才“入”,“离”,“调”,“转”的整个生命周期进行管理。',
        //     '建立应对企业人才“选”，“用”，“育”，“留”的全方位管理体系和制度落地，建立标准的业务流程，赋能企业HR管理者，提升管理效率。',
        //   ],
        // },
      ],
      introductionTagActiveIndex: 0,
    };
  },
  watch: {
    scrollTop(newValue, oldValue) {
      setTimeout(() => {
        if (newValue === window.scrollY) {
          for (var i = 0; i < this.navList.length; i++) {
            var elementTop = this.$refs[`${this.navList[i].id}`].offsetTop - this.scrollTop - 1;
            if (elementTop <= 70) {
              this.topNaviId = this.navList[i].id;
            }
          }
        }
      }, 20);
    },
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
    this.$nextTick(() => {
      const nav = this.$refs.nav;
      this.offsetTop = nav.offsetTop;
    });
    this.getPageColumn();
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      var offsetHeight = this.$refs.navTabs.offsetHeight;
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var headerFixed = this.scrollTop > this.offsetTop - offsetHeight / 2 - 70;
      var scroll = this.scrollTop - this.position;
      this.position = this.scrollTop;
      if (this.scrollTop <= 400) {
        this.navHeight = 52;
        this.navWidth = 80;
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (this.scrollTop >= 400 && !headerFixed) {
        this.navHeight += 0.04 * scroll;
        this.navWidth += 0.12 * scroll;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (headerFixed) {
        this.navHeight = 60;
        this.navWidth = 100;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'fixed';
        this.$refs.nav.style.top = offsetHeight / 2 + 70 + 'px';
      }
    },
    goAnchor(i) {
      window.scrollTo({
        top: this.$refs[`${i.id}`].offsetTop - 70,
        left: 0,
        behavior: 'smooth',
      });
    },

    // 获取页面栏目
    async getPageColumn() {
      const params = { parentId: '1607261022626996224', };
      getColumnChild(params).then(async (res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          if (result[i].name === '管理难点') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                var dataSecurityItem = {
                  title: rtsult.title,
                  icon: rtsult.icon,
                  text: rtsult.description,
                };
                this.dataSecurityList.push(dataSecurityItem);
              }
            });
          } else if (result[i].name === '综合平台') {
            this.architectureImg = result[i].icon;
          } else if (result[i].name === '推荐功能') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var introductionTag = {
                  title: rrsult.data[j].title,
                  img: rrsult.data[j].icon,
                  describeList: [],
                };
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                for (var x = 0; x < rtsult.elements.length; x++) {
                  introductionTag.describeList.push(rtsult.elements[x].content);
                }
                this.introductionTagList.push(introductionTag);
              }
            });
          } else if (result[i].name === '顶部图') {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              var content = rrsult.elements.find(obj => obj.name === 'content').content;
              var contentdoc = new DOMParser().parseFromString(content, 'text/html');
              this.top.title = rrsult.elements.find(obj => obj.name === 'subtitle').content;
              this.top.content = contentdoc.documentElement.textContent.replace(/&nbsp;/g, ' ');
              // this.top = {
              //   imgBack: rrsult.icon,
              // };
            });
          }
        }
      });
    },

    displayTag(index) {
      this.introductionTagActiveIndex = index;
    },
    openBealter () {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style lang="less" scoped>
.cloud-platform{
  background-color: #fff;
  .page-content{
    width: 100%;
    .cloud-platform-canvas {
      width: 100%;
      height: fit-content;
      min-width: var(--minwidth);
      position: relative;
      background-size: cover;
      overflow: hidden;
      .cloud-platform-background {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-position: top;
        background-size: cover;
        background-repeat: no-repeat;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
        }
      }
      .por-container {
        width: 70%;
        max-width: 1200px;
        margin: 0 auto;
        position: relative;
        .solution-info {
          width: 480px;
          height: 560px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          box-sizing: border-box;
          .solution-info-title {
            font-size: 45px;
            font-weight: bold;
            line-height: 55px;
            color: #fff;
            margin-bottom: 29px;
          }
          .solution-info-content {
            font-size: 20px;
            line-height: 32px;
            color: #fff;
            margin-bottom: 44px;
          }
          // .solution-btn {
          //   width: 142px;
          //   height: 48px;
          //   background-color: #1589fd;
          //   color: #fff;
          //   text-align: center;
          //   line-height: 48px;
          //   cursor: pointer;
          //   border-radius: 24px;
          // }
        }
      }
    }
    .staff-manage-nav {
      width: 100%;
      display: flex;
      position: relative;
      justify-content: center;
      z-index: 50;
      .staff-manage-nav-tabs{
        // min-width: var(--minwidth);
        // max-width: 100%;
        margin: 0 auto;
        // min-width: var(--minwidth);
        box-shadow: 0px 2px 8px 0px rgba(139, 139, 139, 0.18);
        border-radius: 2px;
        background-color: #fff;
        display: flex;
        position: absolute;
        // left: 0;
        top: -26px;
        // transition: height .5s;
        .staff-manage-nav-item{
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #181818;
          font-size: 14px;
          cursor: pointer;
        }
        .staff-manage-nav-item:hover{
          color: #00b0dc;
        }
        .top-nav-item {
          color: #ffffff;
          background-color: #00b0dc;
        }
        .top-nav-item:hover {
          color: #fff;
        }
      }
    }
    .data-security{
      width: 1200px;
      padding-top: 70px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
      }
      .data-security-content{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 70px;
        .data-security-list-item{
          width: 380px;
          height: 400px;
          display: flex;
          flex-direction: column;
          align-items: center;
          background-color: #f7f9fc;
          border-radius: 12px;
          padding-top: 65px;
          box-sizing: border-box;
          .list-item-icon{
            width: auto;
            height: 117px;
            margin-bottom: 7px;
          }
          .list-item-title{
            font-size: 18px;
            color: #181818;
            font-weight: 500;
            margin-bottom: 35px;
          }
          .data-security-text{
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .list-item-text{
              width: 297px;
              font-size: 16px;
              color: #6d717c;
              text-align: center;
              line-height: 25px;
            }
          }
        }
      }
    }
    .architecture{
      width: 1200px ;
      // min-width: var(--minwidth);
      padding-top: 119px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        margin-bottom: 70px;
      }
      .architecture-content{
        width: 100%;
        img{
          width: 100%;
        }
      }
    }
    .introduction{
      width: 1200px;
      padding-top: 109px;
      padding-bottom: 50px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        padding-bottom: 90px;
        box-sizing: border-box;
      }
      .introduction-content{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .introduction-tag{
          width: 440px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .introduction-tag-item{
            width: 100%;
            height: 83px;
            padding: 31px;
            margin-bottom: 16px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            box-sizing: border-box;
            background-color: #f5f7f9;
            border-radius: 8px;
            cursor: pointer;
            transition: all .3s ease-in-out;
            .tag-item-title {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              transition: all .3s ease-in-out;
              margin-bottom: 20px;
              .title-text{
                font-weight: 600;
                font-size: 18px;
                color: #181818;
                transition: all .3s ease-in-out;
              }
            }
            .tag-item-describe{
              width: 100%;
              flex: 1;
              overflow: hidden;
              .describe{
                font-size: 16px;
                font-weight: 300;
                color: #181818;
                line-height: 25px;
                transition: all .3s ease-in-out;
              }
            }
          }
          .display-tag-item{
            height: 230px;
            background: url('@/assets/cloudplatform/introduction-tag.png') no-repeat;
            background-size: cover;
            .tag-item-title{
              .title-text{
                color: #fff;
              }
            }
            .tag-item-describe{
              .describe{
                color: #fff;
              }
            }
          }
          .introduction-tag-item:last-child{
            margin: 0;
          }
        }
        .introduction-fade-enter-active {
          animation: bounce-in 0.5s;
        }
        .introduction-fade-leave-active {
          animation: bounce-in 0.3s reverse;
        }
        @keyframes bounce-in {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
      }
    }
    // .data-download{
    //   width: 1200px;
    //   padding-top: 70px;
    //   margin: 0 auto;
    //   display: flex;
    //   flex-direction: column;
    //   justify-content: center;
    //   align-items: center;
    //   .title{
    //     font-size: 32px;
    //     color: #181818;
    //   }
    //   .data-download-content{
    //     display: flex;
    //     margin: 70px auto 0;
    //     .data-download-content-item{
    //       width: 380px;
    //       height: 330px;
    //       margin-right: 30px;
    //       box-sizing: border-box;
    //       border: 1px solid #ddd;
    //       background-color: #fff;
    //       border-radius: 8px;
    //       .item-title-box{
    //         width: 100%;
    //         height: 168px;
    //         padding: 29px;
    //         box-sizing: border-box;
    //         display: flex;
    //         flex-direction: column;
    //         align-items: flex-start;
    //         justify-content: center;
    //         position: relative;
    //         .background{
    //           position: absolute;
    //           top: 0;
    //           left: 0;
    //           right: 0;
    //           bottom: 0;
    //           display: block;
    //           width: 100%;
    //           height: auto;
    //         }
    //         .eng_title{
    //           font-size: 12px;
    //           opacity: 0.8;
    //           color: #fff;
    //           line-height: 1;
    //         }
    //         .ch_title{
    //           display: flex;
    //           align-items: center;
    //           justify-content: flex-start;
    //           z-index: 99;
    //           margin-top: 16px;
    //           .dataListTitle{
    //             font-size: 18px;
    //             color: #fff;
    //             line-height: 1;
    //             font-weight: bold;
    //             padding-right: 9px;
    //             border-right: 2px solid #ffffff;
    //           }
    //           .subTitle{
    //             padding-left: 10px;
    //             line-height: 1;
    //             font-size: 18px;
    //             color: #ffffff;
    //           }
    //         }
    //       }
    //       .data-list{
    //         width: 100%;
    //         padding: 14px 30px 0 30px;
    //         box-sizing: border-box;
    //         display: flex;
    //         flex-direction: column;
    //         justify-content: flex-start;
    //         .data-list-item{
    //           width: 100%;
    //           display: flex;
    //           justify-content: space-between;
    //           margin-top: 21px;
    //           box-sizing: border-box;
    //           list-style:disc;
    //           .data-list-left{
    //             display: flex;
    //             align-items: center;
    //             justify-content: flex-start;
    //             .content-time{
    //               color: #6d717c;
    //               font-size: 12px;

    //             }
    //             .data-title{
    //               width: 260px;
    //               overflow: hidden;
    //               white-space: nowrap;
    //               text-overflow: ellipsis;
    //               font-size: 14px;
    //               color: #181818;
    //               cursor: pointer;
    //               position: relative;
    //               margin-left: 15px;
    //             }
    //           }
    //         }
    //         .data-list-item:hover{
    //           .data-list-left{
    //             .disc{
    //               background-color: #2979ff;
    //             }
    //             .data-title{
    //               color: #2979ff;
    //             }
    //           }
    //           .data-list-right{
    //             display: block;
    //           }
    //         }
    //       }
    //     }
    //     .data-download-content-item:last-child{
    //       margin-right: 0;
    //     }
    //   }
    // }
    // .customer-stories {
    //   display: flex;
    //   flex-direction: column;
    //   padding: 69px 0 60px;
    //   box-sizing: border-box;
    //   .customer-stories-content {
    //     width: 1200px;
    //     // min-width: var(--minwidth);
    //     margin: 0 auto;
    //     display: flex;
    //     flex-direction: column;
    //     align-items: center;
    //     .title {
    //       display: flex;
    //       justify-content: center;
    //       align-items: center;
    //       font-size: 16px;
    //       font-weight: 500;
    //       color: #59697d;
    //       margin-bottom: 64px;
    //       position: relative;
    //     }
    //     .title::before {
    //       position: absolute;
    //       left: -516px;
    //       content: "";
    //       width: 494px;
    //       height: 1px;
    //       background-color: #c0c0c0;
    //     }
    //     .title::after {
    //       position: absolute;
    //       right: -516px;
    //       content: "";
    //       width: 494px;
    //       height: 1px;
    //       background-color: #c0c0c0;
    //     }
    //     .customer-stories-list {
    //       width: 100%;
    //       display: flex;
    //       flex-wrap: wrap;
    //       justify-content: flex-start;
    //       .cystiner-stirues-item {
    //         width: calc(14.285% - 56px);
    //         height: 36px;
    //         margin: 27px;
    //         background-color: #fff;
    //         display: flex;
    //         justify-content: center;
    //         align-items: center;
    //       }
    //     }
    //     .customer-stories-btn {
    //       width: 124px;
    //       height: 42px;
    //       background-color: #2979ff;
    //       border-radius: 8px;
    //       display: flex;
    //       justify-content: center;
    //       align-items: center;
    //       margin-top: 30px;
    //       cursor: pointer;
    //       position: relative;
    //       .btn-text {
    //         font-size: 15px;
    //         color: #ffffff;
    //       }
    //     }
    //     .customer-stories-btn::before {
    //       position: absolute;
    //       left: -538px;
    //       content: "";
    //       width: 494px;
    //       height: 1px;
    //       background-color: #c0c0c0;
    //     }
    //     .customer-stories-btn::after {
    //       position: absolute;
    //       right: -538px;
    //       content: "";
    //       width: 494px;
    //       height: 1px;
    //       background-color: #c0c0c0;
    //     }
    //   }
    // }
    // .appointment-demonstration {
    //   width: 100%;
    //   height: 126px;
    //   background-image: url("@/assets/personnelgrow/appointment-demonstration.png");
    //   background-repeat: no-repeat;
    //   background-size: cover;
    //   color: #fff;
    //   // padding: 22px;
    //   box-sizing: border-box;
    //   .content-center {
    //     width: 1200px;
    //     height: 100%;
    //     margin: 0 auto;
    //     display: flex;
    //     justify-content: space-between;
    //     align-items: center;
    //     .appointment-demonstration-text {
    //       .appointment-demonstration-title {
    //         font-size: 22px;
    //         color: #fff;
    //         font-weight: 500;
    //         margin-bottom: 16px;
    //         line-height: 1;
    //       }
    //       .appointment-demonstration-subtitle {
    //         font-size: 16px;
    //         font-weight: 400;
    //         color: #fff;
    //         line-height: 1;
    //       }
    //     }
    //     .appointment-demonstration-btn {
    //       width: 124px;
    //       height: 42px;
    //       text-align: center;
    //       display: flex;
    //       justify-content: center;
    //       align-items: center;
    //       border-radius: 8px;
    //       border: 1px solid #fff;
    //       line-height: 42px;
    //       cursor: pointer;
    //       font-size: 14px;
    //       font-weight: 400;
    //       // img{
    //       //   width: 18px;
    //       //   height: 42px;
    //       //   vertical-align: middle;
    //       // }
    //       transition: all 0.5s;
    //       // &:hover{
    //       //   transform: scale(1.1);
    //       //   transition: all  0.5s;
    //       // }
    //     }
    //   }
    // }
  }
}
</style>
